(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var timer;

    function init() {
      clearInterval(timer);
      var bar = document.querySelector('[data-announcement]');
      if (!bar) return;

      // When pinned with the header, expose its height so the sticky header can
      // sit just below it.
      if (bar.classList.contains('is-sticky')) {
        var setHeight = function () {
          document.documentElement.style.setProperty('--ann-h', bar.offsetHeight + 'px');
        };
        setHeight();
        window.addEventListener('resize', setHeight);
      }

      var items = bar.querySelectorAll('.announcement__item');
      if (items.length < 2) return;
      var i = 0;
      var interval = parseInt(bar.dataset.interval, 10) || 4000;
      timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var cfg = root.dataset;
    var sectionId = cfg.sectionId;

    var updateCounts = function (n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n < 1;
      });
    };

    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    var stampNow = function () {
      var d = new Date();
      return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    };

    // The checkout button stays clickable on purpose. A greyed-out button that
    // does nothing reads as broken; blocking the submit and saying why is
    // clearer. With JavaScript off, the checkbox's own `required` attribute
    // makes the browser refuse the same submit.
    var showTermsError = function (form, show) {
      var msg = form.querySelector('[data-terms-error]');
      var label = form.querySelector('.cart-terms');
      if (msg) msg.hidden = !show;
      if (label) label.classList.toggle('cart-terms--error', show);
    };

    var swap = function (data) {
      if (typeof data.item_count === 'number') updateCounts(data.item_count);
      if (data.sections && data.sections[sectionId]) {
        var doc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var current = root.querySelector('[data-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
      }
    };

    var change = function (key, quantity, properties) {
      var body = { id: key, quantity: quantity, sections: sectionId, sections_url: window.location.pathname };
      if (properties) body.properties = properties;
      return fetch(cfg.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      }).then(swap);
    };

    // Discount codes: the current list lives in the markup (data-codes) so it
    // is re-read after every swap. An empty string clears all codes.
    var readList = function (attr) {
      var box = root.querySelector('[data-coupon]');
      try { return JSON.parse(box.getAttribute(attr)) || []; }
      catch (err) { return []; }
    };

    var currentCodes = function () { return readList('data-codes'); };

    // Non-code discount titles in a /cart JSON response (line and cart level).
    var otherDiscounts = function (cart, codes) {
      var upper = codes.map(function (c) { return c.toUpperCase(); });
      var titles = [];
      var add = function (title, amount) {
        if (!title || amount <= 0) return;
        if (upper.indexOf(String(title).toUpperCase()) !== -1) return;
        if (titles.indexOf(title) === -1) titles.push(title);
      };
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          add(a.discount_application && a.discount_application.title, a.amount);
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (a) {
        add(a.title, a.total_allocated_amount);
      });
      return titles;
    };

    var fill = function (template, code, title) {
      return template.replace('__CODE__', code).replace('__TITLE__', title);
    };

    var setCodes = function (codes, newCode) {
      var before = readList('data-other-discounts');
      return fetch(cfg.updateUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          discount: codes.join(','),
          sections: sectionId,
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('discount failed');
        return r.json();
      }).then(function (data) {
        var rejected = false;
        if (newCode) {
          var found = (data.discount_codes || []).filter(function (c) {
            return c.code.toUpperCase() === newCode;
          })[0];
          rejected = !found || !found.applicable;
        }
        // A rejected code would stay on the cart unseen (the list only shows
        // applied codes), so take it back off before reporting the error.
        // Shopify gives no reason for a rejection; if another discount is on
        // the cart, the likely one is that the two can't be combined.
        if (rejected) {
          var message = before.length
            ? fill(cfg.tCouponNotCombinable, newCode, before.join(', '))
            : cfg.tCouponError;
          return setCodes(codes.filter(function (c) { return c.toUpperCase() !== newCode; }), null)
            .then(function () { showCouponError(message); });
        }
        swap(data);
        // Accepted, but Shopify dropped a discount it can't combine with
        // (it keeps whichever saves the shopper more): say so, or the old
        // discount just silently vanishes.
        if (newCode) {
          var after = otherDiscounts(data, codes);
          var lost = before.filter(function (t) { return after.indexOf(t) === -1; });
          if (lost.length) showCouponError(fill(cfg.tCouponReplaced, newCode, lost.join(', ')), true);
        }
      });
    };

    var showCouponError = function (text, info) {
      var err = root.querySelector('[data-coupon-error]');
      if (!err) return;
      err.textContent = text;
      err.classList.toggle('cart-coupon__error--info', !!info);
      err.hidden = false;
    };

    var applyCoupon = function () {
      var input = root.querySelector('[data-coupon-input]');
      var btn = root.querySelector('[data-coupon-apply]');
      if (!input || !btn || btn.disabled) return;
      var code = input.value.replace(/^\s+|\s+$/g, '').toUpperCase();
      if (!code) return;
      var codes = currentCodes();
      if (codes.map(function (c) { return c.toUpperCase(); }).indexOf(code) === -1) codes.push(code);
      btn.disabled = true;
      setCodes(codes, code).catch(function () {
        btn.disabled = false;
        showCouponError(cfg.tCouponError);
      });
    };

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-coupon-input]')) {
        e.preventDefault();
        applyCoupon();
      }
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-coupon-apply]')) { applyCoupon(); return; }
      var removeBtn = e.target.closest('[data-coupon-remove]');
      if (removeBtn) {
        var gone = removeBtn.getAttribute('data-coupon-remove').toUpperCase();
        removeBtn.disabled = true;
        setCodes(currentCodes().filter(function (c) { return c.toUpperCase() !== gone; }), null)
          .catch(function () { removeBtn.disabled = false; });
        return;
      }

      var item = e.target.closest('[data-key]');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var span = item.querySelector('.cart-qty span');
      var qty = span ? parseInt(span.textContent, 10) : 1;

      if (e.target.closest('[data-note-toggle]')) {
        var editor = item.querySelector('[data-note-editor]');
        if (editor) {
          editor.hidden = !editor.hidden;
          if (!editor.hidden) editor.querySelector('[data-note-input]').focus();
        }
        return;
      }
      if (e.target.closest('[data-note-cancel]')) {
        var ed = e.target.closest('[data-note-editor]');
        if (ed) ed.hidden = true;
        return;
      }
      var saveBtn = e.target.closest('[data-note-save]');
      if (saveBtn) {
        // Liquid's `| json` serializes line item properties as an array of
        // [key, value] pairs, not an object — normalize before merging.
        var raw = null;
        try { raw = JSON.parse(item.getAttribute('data-props')); }
        catch (err) { raw = null; }
        var props = {};
        if (Array.isArray(raw)) {
          raw.forEach(function (pair) {
            if (pair && pair.length === 2) props[pair[0]] = pair[1];
          });
        } else if (raw && typeof raw === 'object') {
          props = raw;
        }
        var input = item.querySelector('[data-note-input]');
        var val = input ? input.value.replace(/^\s+|\s+$/g, '') : '';
        // An empty string clears the note: Shopify ignores a request that
        // tries to reset properties to an empty object.
        props[cfg.noteKey] = val;

        saveBtn.classList.add('gs-loading');
        saveBtn.disabled = true;
        change(key, qty, props).then(function () {
          if (window.giftToast) window.giftToast.show(cfg.tNoteSaved);
        }).catch(function () {
          saveBtn.classList.remove('gs-loading');
          saveBtn.disabled = false;
          if (window.giftToast) window.giftToast.show(cfg.tNoteError, 'error');
        });
        return;
      }

      var swallow = function () {};
      if (e.target.closest('[data-qty-up]')) change(key, qty + 1).catch(swallow);
      else if (e.target.closest('[data-qty-down]')) change(key, Math.max(0, qty - 1)).catch(swallow);
      else if (e.target.closest('[data-remove]')) change(key, 0).catch(swallow);
    });

    var postUpdate = function (body) {
      fetch(cfg.updateUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    };

    var setAttr = function (key, value) {
      var attrs = {};
      attrs[key] = value;
      postUpdate({ attributes: attrs });
    };

    root.addEventListener('change', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (note) { postUpdate({ note: note.value }); return; }

      var termsBox = e.target.closest('[data-terms-checkbox]');
      if (termsBox) {
        var hidden = root.querySelector('[data-terms-stamp]');
        var value = '';
        if (termsBox.checked && hidden) {
          var template = hidden.getAttribute('data-terms-stamp-template') || '__DATE__';
          value = template.replace('__DATE__', stampNow());
          hidden.value = value;
        }
        // Persist immediately: a later quantity change re-renders the cart from
        // the server, and the tick must survive that swap.
        if (hidden) setAttr(hidden.getAttribute('data-terms-key'), value);
        var termsForm = termsBox.closest('[data-terms-form]');
        if (termsForm && termsBox.checked) showTermsError(termsForm, false);
        return;
      }
    });

    // Submit bubbles, so this survives the cart being re-rendered and swapped.
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-terms-form]');
      if (!form) return;
      var box = form.querySelector('[data-terms-checkbox]');
      if (!box || box.checked) return;

      e.preventDefault();
      showTermsError(form, true);
      box.focus();
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.feedReady) return;
      root.dataset.feedReady = 'true';
      if (!('IntersectionObserver' in window)) return;

      var grid = root.querySelector('[data-feed-grid]');
      var more = root.querySelector('[data-feed-next]');
      if (!grid || !more) return;

      root.classList.add('is-enhanced');
      var loading = false;

      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) load();
      }, { rootMargin: '600px 0px' });

      function load() {
        var next = more.getAttribute('data-feed-next');
        if (loading || !next) return;
        loading = true;
        root.classList.add('is-loading');

        var url = new URL(next, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);

        fetch(url.toString())
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-feed-grid]');
            if (nextGrid) {
              Array.prototype.forEach.call(nextGrid.children, function (card) {
                grid.appendChild(document.importNode(card, true));
              });
            }
            var nextMore = doc.querySelector('[data-feed-next]');
            if (nextMore) {
              more.setAttribute('data-feed-next', nextMore.getAttribute('data-feed-next'));
            } else {
              observer.disconnect();
              more.remove();
            }
          })
          .catch(function () {
            observer.disconnect();
            root.classList.remove('is-enhanced');
          })
          .finally(function () {
            loading = false;
            root.classList.remove('is-loading');
          });
      }

      observer.observe(more);
    }

    function initAll() {
      document.querySelectorAll('[data-collection-feed]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-filter-toggle]');
    var filters = document.querySelector('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        filters.classList.toggle('is-open');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      if (window.giftCart) window.giftCart.open();
      return;
    }
    if (e.target.closest('[data-fav-open]')) {
      e.preventDefault();
      if (window.giftFav) window.giftFav.open();
      return;
    }
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      if (window.giftSearch) window.giftSearch.open();
      return;
    }
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      if (window.giftMenu) window.giftMenu.open();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-plush"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(root) {
      if (root.dataset.heroInit === 'true') return;
      var slides = root.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      root.dataset.heroInit = 'true';

      var track = root.querySelector('.hero__slides');
      var dots = root.querySelectorAll('.hero__dot');
      var interval = parseInt(root.dataset.autoplay, 10) || 5000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var paused = false;
      var fitHeight = root.classList.contains('hero--overlay-dots');

      function fit() {
        if (!fitHeight) return;
        track.style.height = slides[index].offsetHeight + 'px';
      }

      function goTo(target) {
        index = (target + slides.length) % slides.length;
        track.style.transform = 'translateX(' + index * -100 + '%)';
        fit();
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) {
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('inert', '');
          }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || paused) return;
        timer = setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      if (fitHeight) {
        fit();
        window.addEventListener('resize', fit);
        root.querySelectorAll('.hero__image').forEach(function (img) {
          img.addEventListener('load', fit);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.slideTo, 10));
          start();
        });
      });

      var prevButton = root.querySelector('[data-slide-prev]');
      var nextButton = root.querySelector('[data-slide-next]');
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goTo(index - 1);
          start();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goTo(index + 1);
          start();
        });
      }

      // Touch: the track follows the finger, then snaps to the nearest slide.
      var dragStartX = 0;
      var dragStartY = 0;
      var dragDX = 0;
      var dragging = false;
      var axisLocked = false;
      var suppressClick = false;

      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        dragStartX = e.touches[0].clientX;
        dragStartY = e.touches[0].clientY;
        dragDX = 0;
        dragging = true;
        axisLocked = false;
        suppressClick = false;
        stop();
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!dragging || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - dragStartX;
        var dy = e.touches[0].clientY - dragStartY;
        if (!axisLocked) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          axisLocked = true;
          // A mostly-vertical first move is the page scrolling, not a swipe.
          if (Math.abs(dy) > Math.abs(dx)) {
            dragging = false;
            return;
          }
        }
        dragDX = dx;
        suppressClick = true;
        track.style.transition = 'none';
        track.style.transform = 'translateX(calc(' + index * -100 + '% + ' + dx + 'px))';
      }, { passive: true });

      function endDrag() {
        if (!dragging) {
          start();
          return;
        }
        dragging = false;
        track.style.transition = '';
        // Flush the transition change so the snap animates instead of jumping.
        void track.offsetWidth;
        if (Math.abs(dragDX) > (root.offsetWidth || 1) * 0.15) {
          if (dragDX < 0) {
            goTo(index + 1);
          } else {
            goTo(index - 1);
          }
        } else {
          goTo(index);
        }
        dragDX = 0;
        start();
      }

      track.addEventListener('touchend', endDrag);
      track.addEventListener('touchcancel', endDrag);

      // A swipe must not open the link sitting under the finger.
      track.addEventListener('click', function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      // Theme editor: show the selected slide and pause while editing.
      document.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest ? event.target.closest('.hero__slide') : null;
        if (!slide || !root.contains(slide)) return;
        paused = true;
        stop();
        goTo(Array.prototype.indexOf.call(slides, slide));
      });
      document.addEventListener('shopify:block:deselect', function (event) {
        if (!root.contains(event.target)) return;
        paused = false;
        start();
      });

      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-addresses]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var newToggle = e.target.closest('[data-address-new-toggle]');
      if (newToggle) {
        var panel = root.querySelector('[data-address-new]');
        if (panel) panel.hidden = !panel.hidden;
        return;
      }
      var editToggle = e.target.closest('[data-address-edit-toggle]');
      if (editToggle) {
        var id = editToggle.getAttribute('data-address-edit-toggle');
        var edit = root.querySelector('[data-address-edit="' + id + '"]');
        if (edit) edit.hidden = !edit.hidden;
        return;
      }
    });

    root.addEventListener('submit', function (e) {
      var del = e.target.closest('[data-address-delete]');
      if (del && !window.confirm(del.getAttribute('data-confirm') || 'Delete?')) {
        e.preventDefault();
      }
    });

    // Preselect country for edit selects
    root.querySelectorAll('select[data-default-country]').forEach(function (sel) {
      var val = sel.getAttribute('data-default-country');
      if (val) sel.value = val;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-login]');
    if (!root) return;
    var loginView = root.querySelector('[data-login-view]');
    var recoverView = root.querySelector('[data-recover-view]');

    var show = function (recover) {
      loginView.hidden = recover;
      recoverView.hidden = !recover;
    };

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-recover-open]')) { e.preventDefault(); show(true); }
      else if (e.target.closest('[data-recover-close]')) { e.preventDefault(); show(false); }
    });

    if (window.location.hash === '#recover' || root.querySelector('[data-recover-success]')) {
      show(true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-product-page]');
    if (!root) return;

    var cfg = root.dataset;
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var priceDisplay = root.querySelector('[data-price-display]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    // variantId -> gallery image index, built in Liquid (see the capture above).
    var variantImageMap = {};
    (root.getAttribute('data-variant-image-map') || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && kv[0]) variantImageMap[kv[0].trim()] = parseInt(kv[1], 10);
    });

    // ---- Gallery: a sliding track of product images ----
    var galleryTrack = root.querySelector('[data-gallery-track]');
    var gallerySlides = galleryTrack
      ? Array.prototype.slice.call(galleryTrack.querySelectorAll('[data-slide]'))
      : [];
    var galleryIndex = 0;

    // The hover magnifier and the lightbox both need whichever image is on
    // screen right now, not a fixed element.
    function currentImage() {
      if (gallerySlides.length) return gallerySlides[galleryIndex].querySelector('img');
      return root.querySelector('[data-main-image]');
    }

    function galleryGoTo(target) {
      if (!galleryTrack || !gallerySlides.length) return;
      galleryIndex = (target + gallerySlides.length) % gallerySlides.length;
      galleryTrack.style.transform = 'translateX(' + galleryIndex * -100 + '%)';
      gallerySlides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === galleryIndex);
      });
      root.querySelectorAll('[data-thumb]').forEach(function (t, i) {
        t.classList.toggle('is-active', i === galleryIndex);
      });
      root.dispatchEvent(new CustomEvent('gallery:change', { detail: { index: galleryIndex } }));
    }

    if (galleryTrack && gallerySlides.length > 1) {
      var gStartX = 0;
      var gStartY = 0;
      var gDX = 0;
      var gDragging = false;
      var gAxisLocked = false;
      var gSuppressClick = false;

      galleryTrack.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        gStartX = e.touches[0].clientX;
        gStartY = e.touches[0].clientY;
        gDX = 0;
        gDragging = true;
        gAxisLocked = false;
        gSuppressClick = false;
      }, { passive: true });

      galleryTrack.addEventListener('touchmove', function (e) {
        if (!gDragging || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - gStartX;
        var dy = e.touches[0].clientY - gStartY;
        if (!gAxisLocked) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          gAxisLocked = true;
          // A mostly-vertical first move is the page scrolling, not a swipe.
          if (Math.abs(dy) > Math.abs(dx)) {
            gDragging = false;
            return;
          }
        }
        gDX = dx;
        gSuppressClick = true;
        galleryTrack.style.transition = 'none';
        galleryTrack.style.transform =
          'translateX(calc(' + galleryIndex * -100 + '% + ' + dx + 'px))';
      }, { passive: true });

      var endGalleryDrag = function () {
        if (!gDragging) return;
        gDragging = false;
        galleryTrack.style.transition = '';
        // Flush the transition change so the snap animates instead of jumping.
        void galleryTrack.offsetWidth;
        if (Math.abs(gDX) > (galleryTrack.offsetWidth || 1) * 0.15) {
          galleryGoTo(gDX < 0 ? galleryIndex + 1 : galleryIndex - 1);
        } else {
          galleryGoTo(galleryIndex);
        }
        gDX = 0;
      };

      galleryTrack.addEventListener('touchend', endGalleryDrag);
      galleryTrack.addEventListener('touchcancel', endGalleryDrag);

      // A swipe must not count as a tap on the gallery (which opens the lightbox).
      galleryTrack.addEventListener('click', function (e) {
        if (!gSuppressClick) return;
        gSuppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    // Let the lightbox read and drive the gallery.
    root.galleryApi = {
      getIndex: function () { return galleryIndex; },
      goTo: galleryGoTo,
      count: function () { return gallerySlides.length; }
    };

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    };

    var selectedValues = function () {
      var values = [];
      root.querySelectorAll('.product-option').forEach(function (group) {
        var active = group.querySelector('.product-pill.is-selected');
        if (active) values.push(active.getAttribute('data-value'));
      });
      return values;
    };

    var findVariant = function (values) {
      if (!values.length) return variants[0];
      return variants.find(function (v) {
        return v.options.length === values.length && v.options.every(function (opt, i) { return opt === values[i]; });
      });
    };

    var currentVariant = function () {
      return findVariant(selectedValues()) || variants[0];
    };

    var updateUI = function () {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;

      var priceHtml;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (onSale) {
        var percent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        priceHtml = '<span class="product-info__price--sale">' + money(v.price) + '</span> <s class="product-info__price--was">' + money(v.compare_at_price) + '</s>';
        if (percent > 0) {
          priceHtml += ' <span class="product-info__badge">' + cfg.tSalePercent.replace('__PERCENT__', percent) + '</span>';
        }
      } else {
        priceHtml = '<span>' + money(v.price) + '</span>';
      }
      if (priceDisplay) priceDisplay.innerHTML = priceHtml;
      if (stickyPrice) {
        stickyPrice.innerHTML = onSale
          ? '<s class="product-sticky__was">' + money(v.compare_at_price) + '</s> ' + money(v.price)
          : money(v.price);
      }

      root.querySelectorAll('[data-add-btn]').forEach(function (btn) {
        btn.disabled = !v.available;
        var t = btn.querySelector('[data-add-text]');
        if (t) t.textContent = v.available ? cfg.tAdd : cfg.tSold;
      });

      root.querySelectorAll('[data-buy-now]').forEach(function (btn) {
        btn.disabled = !v.available;
      });

      // The variant's image is one of the slides — move to it instead of
      // rewriting a src, which no longer exists as a single element.
      var mappedImage = variantImageMap[v.id];
      if (typeof mappedImage === 'number' && !isNaN(mappedImage)) {
        galleryGoTo(mappedImage);
      }
    };

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-option-value]');
      if (pill) {
        var group = pill.closest('.product-option');
        group.querySelectorAll('.product-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        updateUI();
        return;
      }
      if (e.target.closest('[data-qty-up]')) { qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1; return; }
      if (e.target.closest('[data-qty-down]')) { qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1); return; }

      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        galleryGoTo(parseInt(thumb.getAttribute('data-index'), 10) || 0);
        return;
      }

      // Sticky add button (outside the form)
      var stickyAdd = e.target.closest('.product-sticky [data-add-btn]');
      if (stickyAdd) { addToCart(); return; }

      var buyBtn = e.target.closest('[data-buy-now]');
      if (buyBtn) { buyNow(buyBtn); }
    });

    var lineProps = function () {
      var noteInput = root.querySelector('[data-line-note]');
      var note = noteInput ? noteInput.value.replace(/^\s+|\s+$/g, '') : '';
      if (!note) return null;
      var props = {};
      props[root.dataset.noteKey] = note;
      return props;
    };

    var addToCart = function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      var qty = parseInt(qtyInput.value || 1, 10);
      if (!window.giftCart) return;

      window.giftCart.add(v.id, qty, lineProps()).then(function () {
        var noteInput = root.querySelector('[data-line-note]');
        if (noteInput) noteInput.value = '';
      });
    };

    var buyNow = function (btn) {
      var v = currentVariant();
      if (!v || !v.available) return;
      var qty = parseInt(qtyInput.value || 1, 10);

      var line = { id: v.id, quantity: qty };
      var props = lineProps();
      if (props) line.properties = props;

      btn.disabled = true;
      fetch(cfg.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        // Goes to the cart, not straight to checkout: the distance sales
        // agreement has to be accepted there before payment.
        window.location.href = window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
      }).catch(function () {
        btn.disabled = false;
      });
    };

    var form = root.querySelector('.product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.giftCart) return; // no JS cart -> allow normal submit
        e.preventDefault();
        addToCart();
      });
    }

    // Hover magnifier / zoom popup (pointer devices only)
    var zoomArea = root.querySelector('[data-zoom-area]');
    var zoomBox = root.querySelector('[data-zoom]');
    var lens = root.querySelector('[data-zoom-lens]');
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    if (zoomArea && zoomBox && currentImage() && canHover) {
      var ZOOM = 2.2;

      var showZoom = function () {
        zoomBox.classList.add('is-visible');
        if (lens) lens.classList.add('is-visible');
      };
      var hideZoom = function () {
        zoomBox.classList.remove('is-visible');
        if (lens) lens.classList.remove('is-visible');
      };

      zoomArea.addEventListener('mousemove', function (e) {
        var zoomImg = currentImage();
        if (!zoomImg) { hideZoom(); return; }
        var rect = zoomImg.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        if (x < 0 || y < 0 || x > rect.width || y > rect.height) { hideZoom(); return; }

        showZoom();

        var bgW = rect.width * ZOOM;
        var bgH = rect.height * ZOOM;
        var pw = zoomBox.offsetWidth;
        var ph = zoomBox.offsetHeight;

        zoomBox.style.backgroundImage = 'url("' + zoomImg.src + '")';
        zoomBox.style.backgroundSize = bgW + 'px ' + bgH + 'px';

        var bx = Math.max(0, Math.min(x * ZOOM - pw / 2, bgW - pw));
        var by = Math.max(0, Math.min(y * ZOOM - ph / 2, bgH - ph));
        zoomBox.style.backgroundPosition = '-' + bx + 'px -' + by + 'px';

        if (lens) {
          var lw = pw / ZOOM;
          var lh = ph / ZOOM;
          var lx = Math.max(0, Math.min(x - lw / 2, rect.width - lw));
          var ly = Math.max(0, Math.min(y - lh / 2, rect.height - lh));
          lens.style.width = lw + 'px';
          lens.style.height = lh + 'px';
          lens.style.left = lx + 'px';
          lens.style.top = ly + 'px';
        }
      });

      zoomArea.addEventListener('mouseleave', hideZoom);
    }

    updateUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sub-buybox]').forEach(function (root) {
      var cfg = root.dataset;
      var qtyInput = root.querySelector('[data-sub-qty]');
      var priceEl = root.querySelector('[data-sub-price]');
      var addBtn = root.querySelector('[data-sub-add]');

      var money = function (cents) {
        try {
          return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
        } catch (e) { return (cents / 100).toFixed(2); }
      };

      var checkedRadio = function () { return root.querySelector('[data-sub-radio]:checked'); };

      var refreshPrice = function () {
        var radio = checkedRadio();
        if (!radio || !priceEl) return;
        var cents = parseInt(radio.dataset.planPrice, 10);
        if (!isNaN(cents)) priceEl.textContent = money(cents);
      };

      root.addEventListener('click', function (e) {
        var option = e.target.closest('.sub-product__option');
        if (option) {
          var radio = option.querySelector('[data-sub-radio]');
          if (radio) {
            radio.checked = true;
            root.querySelectorAll('.sub-product__option').forEach(function (o) { o.classList.remove('is-selected'); });
            option.classList.add('is-selected');
            refreshPrice();
          }
          return;
        }
        if (e.target.closest('[data-sub-qty-up]')) { qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1; return; }
        if (e.target.closest('[data-sub-qty-down]')) { qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1); return; }
      });

      var noteProps = function () {
        var noteInput = root.querySelector('[data-sub-note]');
        var note = noteInput ? noteInput.value.replace(/^\s+|\s+$/g, '') : '';
        if (!note) return null;
        var props = {};
        props[cfg.noteKey] = note;
        return props;
      };

      var selectedPlan = function () {
        var radio = checkedRadio();
        return radio && radio.value ? radio.value : null;
      };

      var add = function () {
        var qty = parseInt(qtyInput.value || 1, 10);
        var vid = cfg.variantId;
        if (!vid) return;

        if (window.giftCart) {
          window.giftCart.add(vid, qty, noteProps(), selectedPlan()).then(function () {
            var noteInput = root.querySelector('[data-sub-note]');
            if (noteInput) noteInput.value = '';
          });
          return;
        }

        var line = { id: vid, quantity: qty };
        var props = noteProps();
        if (props) line.properties = props;
        var plan = selectedPlan();
        if (plan) line.selling_plan = plan;
        fetch(cfg.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [line] })
        }).then(function () { window.location.href = '/cart'; });
      };

      if (addBtn) addBtn.addEventListener('click', add);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
